
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 40 41","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"fill":"#eef0f4","height":"28.284","rx":"4","transform":"rotate(-45.004 24.743 10.25)","width":"28.284"}}),_c('g',{attrs:{"stroke":"#0e193f","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M16.957 26.56v-4.083a4 4 0 014-4h6.1m0 0l-3.03-3.03m3.03 3.03l-3.03 3.031","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.957 17.972v-3.536"}})])])
          )
        }
      }
    